import './styles.scss';
import { useEffect, useRef, useState } from 'react';

function useOutsideAlerter(ref, inputRef, id) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        inputRef.current.checked
      ) {
        ref.current.click();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [inputRef, ref, id]);
}

function Select({ field, options, selectedDef, setSelected, disabled }) {
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  useOutsideAlerter(wrapperRef, inputRef, field);

  const [selectedOpt, setSelectedOpt] = useState(null);
  const [selectedOptId, setSelectedOptId] = useState(null);
  const [showOptList, setShowOptList] = useState(false);

  useEffect(() => {
    if (selectedOptId) {
      const optionSelected = options.find(opt => opt.id === selectedOptId);
      setSelectedOpt(optionSelected.value);
      setShowOptList(false);
      setSelected(
        field,
        optionSelected.id,
        field === 'streetType' ? optionSelected.code : optionSelected.value
      );
    }
    const optsWrapper = document.querySelector('#' + field + 'options');
    optsWrapper.style.setProperty(
      '--select-opts-wrapper-height',
      options.length > 3 ? '18rem' : '12rem'
    );
  }, [selectedOptId, selectedOpt, field]);

  useEffect(() => {
    if (selectedDef && (!selectedOpt || !selectedOptId)) {
      const normalizedSelected = selectedDef?.toString().trim().toLowerCase();
      const optById = options.find(
        o => o.id?.toString() === selectedDef?.toString()
      );
      const optByCode = options.find(
        o => o.code?.toString().trim().toLowerCase() === normalizedSelected
      );
      const optByValue = options.find(
        o =>
          o.value?.toString().trim().toLowerCase() === normalizedSelected
      );
      const matchedOption = optById ?? optByCode ?? optByValue;
      if (matchedOption) {
        handleOption(matchedOption);
      }
    }
  }, [selectedDef, options, field]);

  function handleOption(opt) {
    setSelectedOptId(opt?.id);
    setSelectedOpt(opt?.value);
  }

  useEffect(() => {
    const checkbox = document.querySelector(`#${field}`);
    checkbox.checked = showOptList;
  }, [field, options, showOptList]);

  return (
    <div
      className={disabled ? 'select select--disabled' : 'select'}
      ref={wrapperRef}
      onClick={() => setShowOptList(disabled ? false : !showOptList)}>
      <input type='radio' ref={inputRef} name='selectRadio' id={field} />
      <span
        className={selectedOpt ? 'select__text' : 'select__text--placeholder'}>
        {selectedOpt ?? 'Seleccione una opción ...'}
      </span>
      <span className='material-symbols-rounded select__icon'>expand_more</span>
      <div className='select__options opts' id={field + 'options'}>
        {options.map((opt, i) => (
          <div
            className='opts__item item'
            key={i}
            id={opt.id}
            onClick={() => handleOption(opt)}>
            <span className='item__text'>{opt.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Select;
